var map = {
	"./36_Apple.svg": 86517,
	"./36_Facebook.svg": 24578,
	"./36_GooglePlay.svg": 31995,
	"./36_Instagram.svg": 39626,
	"./36_VK.svg": 50298,
	"./36_browser.svg": 16489,
	"./Emoji.svg": 73631,
	"./GreatIDo.svg": 37334,
	"./IDontLike.svg": 42620,
	"./InviteFriendModalIcon.svg": 783,
	"./MobileAppModalIcon.svg": 81090,
	"./Oclock.svg": 75597,
	"./PromoCodeStep1.svg": 91990,
	"./PromoCodeStep2.svg": 41033,
	"./PromoCodeStep3.svg": 36053,
	"./add.svg": 19903,
	"./animals.svg": 9384,
	"./art.svg": 22617,
	"./astrology.svg": 26883,
	"./blogging.svg": 64469,
	"./business.svg": 77682,
	"./call-phone.svg": 89442,
	"./cancel.svg": 73491,
	"./change.svg": 92036,
	"./check.svg": 86380,
	"./children.svg": 63272,
	"./clear.svg": 5837,
	"./closeModalImg.svg": 6291,
	"./close_modal.svg": 36376,
	"./culture.svg": 98334,
	"./dancing.svg": 95684,
	"./desktops.svg": 38408,
	"./empty_balance.svg": 36556,
	"./eng.svg": 89459,
	"./entertainment.svg": 88445,
	"./esp.svg": 43601,
	"./family.svg": 96202,
	"./food.svg": 78089,
	"./full_balance.svg": 80087,
	"./games.svg": 53354,
	"./health.svg": 14787,
	"./history.svg": 16802,
	"./house.svg": 43182,
	"./info.svg": 37708,
	"./knitting.svg": 13249,
	"./left_icon.svg": 12022,
	"./literature.svg": 45098,
	"./mail.svg": 95120,
	"./movie.svg": 75629,
	"./music.svg": 44167,
	"./nature.svg": 5045,
	"./pencil.svg": 16690,
	"./philosophy.svg": 24615,
	"./phone.svg": 28953,
	"./photo.svg": 28567,
	"./policy.svg": 41830,
	"./portugal.svg": 26152,
	"./psychology.svg": 9329,
	"./pt.svg": 23736,
	"./right_icon.svg": 42642,
	"./rus.svg": 5216,
	"./shopping.svg": 55218,
	"./skype.svg": 94584,
	"./smart_emoji.svg": 60178,
	"./speechIcon.svg": 5801,
	"./sport.svg": 84280,
	"./start.svg": 42498,
	"./success_add.svg": 98852,
	"./tech.svg": 9240,
	"./telegram_icon.svg": 17279,
	"./tikTok.svg": 30131,
	"./trash.svg": 63047,
	"./travel.svg": 35653,
	"./ustates.svg": 59624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42587;